"use strict";

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";
import tokenProvider from "vwa/token";
import serviceStore from "./services";

const sessionStore = new Singleton();
export default sessionStore;

window.sessionStore = sessionStore;

dispatcher.on('login', (token, user) => {
	sessionStore.set({token, user})
	tokenProvider.set(token);
});

dispatcher.on('logout', () => {
	sessionStore.set(null)
	tokenProvider.remove();
});

dispatcher.on('invalidToken', () => {
	sessionStore.set(null)
	tokenProvider.remove();
});

dispatcher.on('createPOI', (poi, collaboration) => addServiceSetByCollaboration(poi, collaboration));

dispatcher.on('createNotificationConfig', notificationConfig => addServiceSetByNotificationSet(notificationConfig));

dispatcher.on('updateUser', user => updateUser(user));

function addServiceSetByNotificationSet(notificationConfig) {
	if(!notificationConfig) return;
	const serviceId = serviceStore.get("Notification")._id;
	if(!serviceId) return;
	const session = sessionStore.get();
	if(!session) return;
	
	const serviceSet = {
		accessInterval: {from: null, to: null},
		denied: false,
		service: serviceId,
		value: notificationConfig,
		type: "NotificationSet"
	}
	
	session.user.services = [...session.user.services, serviceSet];
	
	sessionStore.set(session);
}

function addServiceSetByCollaboration(poi, collaboration) {
	if (!poi || !collaboration) return;
	const serviceId = serviceStore.get("POI")._id;
	if (!serviceId) return;
	const session = sessionStore.get();
	if (!session) return;
	
	const serviceSet = {
		accessInterval: {from: null, to: null},
		denied: false,
		service: serviceId,
		type: "POISet",
		value: {
			poi: poi._id,
			privilege: collaboration.privilege
		}
	};
	
	session.user.services = [...session.user.services, serviceSet];
	
	sessionStore.set(session);
}

function updateUser(user) {
	if (!user) return;
	const session = sessionStore.get();
	if (!session) return;
	sessionStore.set({token: session.token, user});
}


// WEBPACK FOOTER //
// ./src/store/session.js